module.exports = __webpack_public_path__ + "img/fridge.953c2f52.png";